import { RequestExplorerContext } from 'contexts/RequestExplorer';
import type { FC } from 'react';
import { useContext } from 'react';
import { EditGrid } from '../../../EditGrid';

type ResponseHeadersProps = {
  locked?: boolean;
};

const ResponseHeaders: FC<ResponseHeadersProps> = ({ locked }) => {
  const ctx = useContext(RequestExplorerContext);
  if (!ctx) {
    // eslint-disable-next-line no-console
    console.error('RequestExplorerContextProvider required');

    return <>RequestExplorerContextProvider required</>;
  }

  return (
    <EditGrid
      columns={{
        key: {
          key: 'key',
          label: 'Key',
          placeholder: 'Key',
          width: '20fr'
        },
        value: {
          key: 'value',
          label: 'Value',
          placeholder: 'Value',
          width: '20fr'
        }
      }}
      value={ctx.state.response?.headers ? ctx.state.response.headers : []}
    />
  );
};
export default ResponseHeaders;
